import { ITeam, TCaseBattleTypes } from '@/utils/types/ICaseBattle';
import { ICaseBattlePlayer } from '@/utils/types/ICaseBattlePlayer';

export const getMaxPlayers = (type: TCaseBattleTypes) => {
    return type != 'TWO_VS_TWO' ? Number(type.split('_')[1]) : undefined;
};

export const isWinner = (id: number, teams: ITeam[]) => {
    return teams?.flatMap((t) => t.participants)?.some((t) => t.userId === id);
};

export const totalUnboxed = (players: ICaseBattlePlayer[]) =>
    Number(
        players
            .reduce(
                (acc, p) => acc + (p.rolls?.reduce((acc, r) => acc + r.item.priceUsd, 0) || 0),
                0
            )
            .toFixed(2)
    );
